module.exports = __webpack_public_path__ + "img/org-chart.7053cb70.jpg";